import { render, staticRenderFns } from "./ActionFormButtonAction.vue?vue&type=template&id=006ab514&scoped=true&"
import script from "./ActionFormButtonAction.vue?vue&type=script&lang=ts&"
export * from "./ActionFormButtonAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ab514",
  null
  
)

export default component.exports